module.exports = __webpack_public_path__ + "fonts/Inter_Illu-Black.ad9dc3f.woff2";